import * as React from "react";
import { PageHead } from "@/components/UI/atoms/PageHead/PageHead";
import { PortalTemplate } from "@/components/templates/PortalTemplate/PortalTemplate";
import { usePage } from "@/hooks/PageContent";
export interface IAccessDeniedProps {}

export function AccessDenied(props: IAccessDeniedProps) {
	return (
		<PortalTemplate>
			<PageHead pageTitle="Access Denied" pageHead="Access Denied">
				<div>
					If you feel you&apos;ve reached this message in error please contact an administrator
				</div>
			</PageHead>
		</PortalTemplate>
	);
}
